import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=86dae4ae&scoped=true&"
import script from "./Puzzle.vue?vue&type=script&lang=js&"
export * from "./Puzzle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dae4ae",
  null
  
)

export default component.exports